<template>
  <div style="position: relative">
    <div style="color: #fccc66; line-height: 30px; position: absolute">
      乡镇企业数排名
    </div>
    <dv-conical-column-chart
      :config="config"
      style="width: 100%; height: 120px"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {
        data: [
          {
            name: '水湖镇',
            value: 101,
          },
          {
            name: '罗塘乡',
            value: 68,
          },
          {
            name: '岗集镇',
            value: 59,
          },
          {
            name: '左店镇',
            value: 52,
          },
          {
            name: '吴山镇',
            value: 43,
          },
          {
            name: '双墩镇',
            value: 43,
          },
          {
            name: '杨庙镇',
            value: 39,
          },
          {
            name: '庄墓镇',
            value: 37,
          },
          {
            name: '陶楼镇',
            value: 36,
          },
          {
            name: '朱巷镇',
            value: 35,
          },
        ],
        showValue: true,
      },
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/summary-zone/entity-amount-rank.vue